import React from "react";
import { Helmet } from "react-helmet-async";

const SEOHead = ({ 
  title, 
  description, 
  keywords,
  image = "https://customer-assets.emergentagent.com/job_premier-b2b-site/artifacts/4ivcj81e_Logo.svg",
  url,
  type = "website"
}) => {
  const siteTitle = "CNESS";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Conscious Business Certification`;
  const siteUrl = "https://cness-works-preview.preview.emergentagent.com";
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title || siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="CNESS" />

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || siteTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "CNESS",
          "description": "Conscious Business Certification Platform",
          "url": siteUrl,
          "logo": image,
          "sameAs": [
            "https://linkedin.com/company/cness",
            "https://twitter.com/cness"
          ],
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-555-CNESS",
            "contactType": "customer service",
            "email": "contact@cness.co"
          }
        })}
      </script>

      {url === "/" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "CNESS",
            "url": siteUrl,
            "potentialAction": {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": `${siteUrl}/search?q={search_term_string}`
              },
              "query-input": "required name=search_term_string"
            }
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;